import type {ReactElement} from 'react';
import {SkeletonBrick, SkeletonBrickTheme} from '@Components/skeleton-brick';
import type {LayerImageProps} from './layer-image.types';

export function LayerImage({role, url, isSettled, onSettle, skeletonClasses, imageClasses}: LayerImageProps): ReactElement {
  const getSkeleton = (): ReactElement | null => {
    if (isSettled) {
      return null;
    }
    return <SkeletonBrick theme={SkeletonBrickTheme.LIGHT} isPulsating={false} className={skeletonClasses} radius="4px" />;
  };

  return (
    <>
      {getSkeleton()}
      <img src={url} alt="" className={imageClasses} data-role={role} data-loaded={isSettled} onLoad={onSettle} onError={onSettle} />
    </>
  );
}
